import { t } from '@lingui/core/macro';
import { AddressRecord } from '@navio/nsdk';
import { BookingAddress } from 'noddi-types';
import { NoddiIcon } from 'noddi-ui-common';
import { getLongAddressName } from 'noddi-web';

interface Props {
  address: AddressRecord | BookingAddress;
  showMapLink?: boolean;
}

export const AddressLine = ({ address, showMapLink = true }: Props) => (
  <div className='flex items-baseline gap-2'>
    <span>{getLongAddressName(address)}</span>
    {showMapLink && (
      <a
        href={address.googleMapsUrl}
        target='_blank'
        rel='noopener noreferrer'
        aria-label={t`Open in Google Maps (opens in a new tab)`}
      >
        <NoddiIcon name='MapPin' />
      </a>
    )}
  </div>
);
